import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/authContext';
import { useUserRole } from '../context/userRoleContext';
import { Box, CircularProgress, Typography } from '@mui/material';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
  const { isLoading: authLoading, isAuthenticated } = useAuth();
  const { userRole, isLoading: roleLoading } = useUserRole();

  const loading = authLoading || roleLoading;
  if (loading && isAuthenticated ) {
    return (
      <Box sx={{ display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', minHeight:'100vh' }}>
        <CircularProgress size={60} thickness={4} />
        <Typography variant="h6" sx={{ mt: 2 }}>Loading application...</Typography>
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && !userRole) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (requiredRole && (!userRole || !requiredRole.some(r => r.toLowerCase() === userRole.toLowerCase()))) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};
